export const bisproLoader = {
  listCVC: 'listCVC',
  listTreeView: 'listTreeView',
  listIndexProcess: 'listIndexProcess',
  listProcessLevel: 'listProcessLevel',
};
export const InitialStateBispro = {
  listCVC: true,
  listTreeView: true,
  listIndexProcess: true,
  listProcessLevel: true,
};
